import React from "react"
import { get } from 'lodash';
import { Box } from "@mui/joy";
import { useTranslation } from 'react-i18next';
import { Icon } from "src/mtska-frontend-app-component/assets";

const MirrorFields = ({ name, formValues, setValue, source, destination, isRelationship = false }) => {
    const value = get(formValues, name);
    const { t } = useTranslation();

    const camelize = (str) => {
        return str
            .replace(/_id$/, '') // rimuove _id finale
            .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()); // cammelizza altri underscore
    };

    const handleMirroring = () => {
        if (isRelationship) {
            const sourceValue = get(formValues, source);
            const normalizedRelationshipValue = Array.isArray(sourceValue) ? sourceValue : [sourceValue];
            //console.info('MirrorFields travaso ', source, 'su', destination, normalizedRelationshipValue, isRelationship)
            setValue(destination, normalizedRelationshipValue, { shouldDirty: true })

            const sourceObjRoute = source.replace(/\.([^.]+)$/, (_, last) => '.' + camelize(last));
            const destinationObjRoute = destination.replace(/\.([^.]+)$/, (_, last) => '.' + camelize(last));
            //console.info('MirrorFields travaso ', sourceObjRoute, 'su', destinationObjRoute, get(formValues, sourceObjRoute), isRelationship)
            setValue(destinationObjRoute, get(formValues, sourceObjRoute), { shouldDirty: true })
        } else {
            //console.info('MirrorFields travaso ', source, 'su', destination, value, isRelationship)
            setValue(destination, value, { shouldDirty: true })
        }
    }

    return (
        <Box className="form-element-value-mirror-wrapper">
            <Box className="form-element-value-mirror-action" onClick={handleMirroring} title={t("Mirror value {{value}} to {{destination}}", { value: value, destination: destination })}>
                <Icon icon="faChevronRight" />
            </Box>
        </Box>
    )
}

export default MirrorFields